import type { IncidentFolderId } from "../../layouts/incidents/lib/constants";

const INCIDENT_ID_KEY = "incidents.workspace.selectedIncidentId";
const FOLDER_KEY = "incidents.workspace.selectedFolder";

export type IncidentsWorkspaceSelection = {
  incidentId: string;
  folder: IncidentFolderId;
};

export type IncidentsLocationState = {
  selectedIncidentId?: string;
  selectedFolder?: IncidentFolderId;
};

export function persistIncidentsWorkspaceSelection(selection: IncidentsWorkspaceSelection) {
  sessionStorage.setItem(INCIDENT_ID_KEY, selection.incidentId);
  sessionStorage.setItem(FOLDER_KEY, selection.folder);
}

export function readIncidentsWorkspaceSelection(): Partial<IncidentsWorkspaceSelection> | null {
  const incidentId = sessionStorage.getItem(INCIDENT_ID_KEY);
  if (!incidentId) return null;

  const folder = sessionStorage.getItem(FOLDER_KEY) as IncidentFolderId | null;
  return { incidentId, folder: folder ?? undefined };
}

export function parseIncidentsLocationState(
  state: unknown,
): Partial<IncidentsWorkspaceSelection> | null {
  if (!state || typeof state !== "object") return null;

  const { selectedIncidentId, selectedFolder } = state as IncidentsLocationState;
  if (!selectedIncidentId) return null;

  return { incidentId: selectedIncidentId, folder: selectedFolder };
}

export function resolveIncidentsWorkspaceRestore(
  locationState: unknown,
): Partial<IncidentsWorkspaceSelection> | null {
  return parseIncidentsLocationState(locationState) ?? readIncidentsWorkspaceSelection();
}
